import React from 'react';
import {
  Header,
  Image,
} from 'semantic-ui-react';

const ChannelPoints = () => {
  return (
    <React.Fragment>
      <Header as='h2' inverted>Channel Points</Header>
      <p>
        Channel Points allows you to setup Channel Point redeems on your stream, as soon as you login to the Mod within the game. Once configured on the website, these
        redemptions will be auto added and removed during each use of the mod. Similarly to the Donation system, commands that are redeemed via Channel Points will
        bypass any limits set on commands, such as cooldown limits, banned inputs, and if the command has been marked disabled. It is important to note that unlike
        Donations, Channel Points can allow the command inputs to be entered as part of a redeem, so keep that in mind with how commands bypass these command
        configurations. When configuring Channel Point redemptions, you can use the Twitch configuration for Channel Points to limit how many redemptions are possible,
        as well as a global cooldown.
      </p>
      <p>
        For example, you have created a Custom Command called <strong>r_key</strong>. You have disabled this command as being accessible via chat, and the purpose
        of the command is to directly activate the R Key. You create a new Channel Point redemption at a cost of 2,500 channel points that will activate this redeem.
        In the Action dropdown, you select your custom command, and since it does not require user input, you leave the Action Parameters empty, and leave User Input
        disabled. Since this is redemption is clearly meant to cause a disturbance to your game, you want to limit it to being redeemed a total of 5 times for your
        stream, and only once per user. You also want to ensure that 30 minutes pass prior to it being able to be redeemed again.
      </p>
      <Image src='/images/support_channel_points.png' />
      <br />
      <p>
        Now the next time you startup Isaac, with the Twitching of Isaac enabled, the Channel Point will automatically be created for you. Once you are done with your
        game, and you close out of Isaac, or disable the mod, it will automatically be deleted for you.
      </p>
      <Header as='h3' inverted>A note about Channel Point images</Header>
      <p>
        Unfortunately, Twitch's API for managing Channel Points currently does not allow setting an image for a redemption. Due to this, the created redeems will
        simply be purple, with the default Channel Point icon. You can however go in to your Twitch account to set the image, but unfortunately this change will NOT
        be persistent, and the next time the redeem is recreated, it will default back to the default image.
      </p>
    </React.Fragment>
  )
};

export default ChannelPoints;
